import { Typography } from "@mui/material";

export const ConsentForm = () => {
  return (
    <>
      <Typography component="div">
        I, the undersigned individual ("I" or "me"), hereby give my consent for
        Qube Hub Inc., Qube Medical Inc., Qube Health Inc., and Qasim
        Technologies Inc. (collectively referred to as "QUBE" or the "Company")
        to connect me with a Healthcare Provider in the Province of Ontario,
        Canada (the "Service"). By signing this agreement (referred to as the
        "Agreement"), I agree to the following terms and conditions:
        <ol>
          <li>
            I understand that the Service does not involve medical advice,
            examination, or any medical treatment. The Company is simply
            providing the technology for the Healthcare Provider who operates as
            an independent contractor.
          </li>
          <li>
            I voluntarily consent to the Company using my personal health
            information.
          </li>
          <li>
            I waive and release any and all claims against the Company, its
            affiliates, and their respective directors, officers, employees,
            agents, representatives, shareholders, successors, and assigns
            (collectively referred to as "Releases"), for any loss of
            information resulting from the Service, regardless of the cause,
            including negligence, breach of contract, or breach of statutory
            duty.
          </li>
          <li>
            I agree to defend, indemnify, and hold harmless the Company and all
            other Releases from any losses, damages, liabilities, deficiencies,
            claims, actions, judgments, settlements, interest, awards,
            penalties, fines, costs, or expenses, including reasonable legal
            fees, arising from any third-party claim, suit, action, or
            proceeding related to the Service.
          </li>
          <li>
            This Agreement represents the entire agreement between the Company
            and me and supersedes any prior understandings, agreements,
            representations, and warranties, whether written or oral, regarding
            the subject matter herein.
          </li>
          <li>
            If any term or provision of this Agreement is deemed invalid,
            illegal, or unenforceable in any jurisdiction, it will not affect
            the validity or enforceability of any other term or provision in
            this Agreement or in any other jurisdiction.
          </li>
          <li>
            This Agreement is binding on me, my heirs, and next-of-kin, as well
            as the Company, its successors, and assigns.
          </li>
        </ol>
      </Typography>
      <br />

      <Typography>
        This Agreement will be governed by and construed in accordance with the
        laws of Ontario and the federal laws of Canada applicable therein. Any
        claim or cause of action arising from this Agreement may only be brought
        in the courts of Ontario, and I consent to the exclusive jurisdiction of
        such courts. By signing this Agreement, I acknowledge that I have read
        and understood all of its terms, and I am voluntarily waiving
        substantial legal rights for myself, my heirs, executors,
        administrators, and next-of-kin, including the right to sue the event
        and the Releases.
      </Typography>
    </>
  );
};
